import type { TableColumn } from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';
import type { TableMergedState } from 'components/Table/model/TableModel';
import { rowSelectionColumn } from 'components/Table/model/rowSelectionColumn';
import { selectTableHasRowSelection } from 'components/Table/model/selectors/selectTableHasRowSelection';
import { array } from 'fp-ts';
import { identity, pipe } from 'fp-ts/lib/function';
import { createSelector } from 'reselect';
import { createScopedSelector } from 'utils/react/scopedSelector';

export const selectAllColumns: (s: TableMergedState) => TableColumn<any>[] =
  createScopedSelector(() =>
    createSelector(
      prop('columns'),
      selectTableHasRowSelection,
      (columns, tableHasRowSelection) => {
        return pipe(
          columns,
          tableHasRowSelection
            ? array.prepend<TableColumn<any>>(rowSelectionColumn)
            : identity,
        );
      },
    ),
  );
